module.exports = new __parcel__URL__("Jetbrains.5019c2b0.svg").toString();